import { render, staticRenderFns } from "./PlayerUnbanAdd.vue?vue&type=template&id=11f30358&"
import script from "./PlayerUnbanAdd.vue?vue&type=script&lang=js&"
export * from "./PlayerUnbanAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports